import { combineReducers } from '@reduxjs/toolkit';

import { userReducer } from './user/user.reducer';
import { CountryReducer } from './countrylist/country.reducer';


export const rootReducer = combineReducers({
    user: userReducer,
    country:CountryReducer
});